import React, { Component } from "react";
import ReactDOM from "react-dom";
import ActivityIndicator from "./activity-indicator";
import ErrorSummary from "./error-summary";

class ModalHalfSiblingsTwinsCheck extends Component {
  render() {
    return ReactDOM.createPortal(
      <div
        onClick={() => this.props.onCancel()}
        style={{ zIndex: 9999, display: this.props.isOpen ? "block" : "none" }}
        className={"modal fade " + (this.props.isOpen ? "in" : "")}
        role="dialog"
      >
        <div
          onClick={e => e.stopPropagation()}
          className="modal-dialog modal-sm"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <button
                onClick={() => this.props.onCancel()}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa fa-close" />
              </button>
              <h4 className="modal-title text-white text-capitalize">
                {this.props.title ? this.props.title : "Half-Sibling and Twin?"}
              </h4>
            </div>

            <div className="modal-body">
              <div className="modal-confirm">

                <p>
                  {this.props.message
                    ? this.props.message
                    : "Making this change will result in this person having a different parent than their twin. If you continue, they will no longer be marked as twins."}
                </p>

                <br />

                <div className="buttons">
                  <button
                    disabled={this.props.loading}
                    onClick={() => this.props.onOk()}
                    className="btn btn-purple btn-sm"
                  >
                    Yes
                  </button>
                  <button
                    disabled={this.props.loading}
                    onClick={() => this.props.onCancel()}
                    className="btn btn-light btn-sm"
                    aria-label="Close"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  }
}

export default ModalHalfSiblingsTwinsCheck;
